(function () {
  const ARROW = '\u25BE';
  const CONTAINER_STYLE = 'display:flex;flex-direction:column;margin:0 0 24px 0;padding:0;gap:0px';
  const DETAILS_STYLE = 'border-bottom:1px solid #E0E0E0';
  const SUMMARY_STYLE = 'list-style:none;cursor:pointer;display:flex;align-items:center;justify-content:space-between;gap:16px';
  const ARROW_STYLE = 'display:inline-flex;align-items:center;justify-content:center;transition:transform 0.2s ease;text-align:justify';
  const BODY_STYLE = 'line-height:1.7';
  const CONTENT_TAGS = new Set(['DIV', 'P', 'UL', 'OL', 'BLOCKQUOTE', 'TABLE', 'FIGURE']);

  function run() {
    if (document.querySelector('.custom-blog-faq-item')) return;

    const h2 = findFaqHeading();
    if (!h2) return;

    const scanContext = findScanContext(h2);
    if (!scanContext) return;

    const { introNodes, faqPairs } = scanContext;
    if (faqPairs.length === 0) return;

    const fragment = buildAccordion(introNodes, faqPairs);
    const nodesToRemove = collectScannedNodes(h2, introNodes, faqPairs);
    nodesToRemove.forEach((node) => node.remove());
    h2.after(fragment);
  }

  function findFaqHeading() {
    const h2List = document.querySelectorAll('h2');
    for (const h2 of h2List) {
      const text = (h2.textContent || '').toLowerCase();
      const hasFaq = text.includes('faq');
      const hasAskOrQuestion = text.includes('ask') || text.includes('question');
      if (hasFaq && hasAskOrQuestion) return h2;
    }
    return null;
  }

  function findScanContext(anchorH2) {
    let node = anchorH2.parentElement;
    while (node) {
      const scanResult = scanSiblings(anchorH2, node);
      if (scanResult.faqPairs.length > 0) {
        return { parent: node, introNodes: scanResult.introNodes, faqPairs: scanResult.faqPairs };
      }
      node = node.parentElement;
    }
    return null;
  }

  function scanSiblings(anchorH2, parent) {
    const introNodes = [];
    const faqPairs = [];
    let currentQuestion = null;
    let currentAnswerNodes = [];
    let foundAnchor = false;
    let introTaken = false;

    for (const child of parent.children) {
      if (child === anchorH2 || child.contains(anchorH2)) {
        foundAnchor = true;
        continue;
      }
      if (!foundAnchor) continue;
      if (child.tagName === 'H2') break;

      if (child.tagName === 'H3') {
        if (currentQuestion) {
          faqPairs.push({ question: currentQuestion, answerNodes: currentAnswerNodes });
        }
        currentQuestion = { element: child, id: child.id || null, text: child.textContent?.trim() || '' };
        currentAnswerNodes = [];
      } else if (currentQuestion) {
        if (isContentNode(child) && currentAnswerNodes.length === 0) {
          currentAnswerNodes.push(child);
        }
      } else if (!introTaken && isContentNode(child)) {
        introNodes.push(child);
        introTaken = true;
      }
    }
    if (currentQuestion) {
      faqPairs.push({ question: currentQuestion, answerNodes: currentAnswerNodes });
    }
    return { introNodes, faqPairs };
  }

  function isContentNode(node) {
    return CONTENT_TAGS.has(node.tagName) && (node.textContent || '').trim() !== '';
  }

  function collectScannedNodes(h2, introNodes, faqPairs) {
    const nodes = [...introNodes];
    for (const pair of faqPairs) {
      nodes.push(pair.question.element);
      nodes.push(...pair.answerNodes);
    }
    return nodes;
  }

  function buildAccordion(introNodes, faqPairs) {
    const container = document.createElement('div');
    container.style.cssText = CONTAINER_STYLE;

    if (introNodes.length > 0) {
      const introWrap = document.createElement('div');
      introNodes.forEach((node) => introWrap.appendChild(node.cloneNode(true)));
      container.appendChild(introWrap);
    }

    faqPairs.forEach((pair, index) => {
      const details = document.createElement('details');
      details.className = 'custom-blog-faq-item';
      details.style.cssText = DETAILS_STYLE;
      if (pair.question.id) {
        details.id = pair.question.id;
      }
      if (index === 0) details.open = true;

      const summary = document.createElement('summary');
      summary.style.cssText = SUMMARY_STYLE;
      if (pair.question.id) {
        summary.id = `${pair.question.id}--summary`;
      }

      const strong = document.createElement('strong');
      strong.textContent = pair.question.text;
      summary.appendChild(strong);

      const arrow = document.createElement('span');
      arrow.textContent = ARROW;
      arrow.style.cssText = ARROW_STYLE;
      arrow.setAttribute('aria-hidden', 'true');
      summary.appendChild(arrow);

      details.appendChild(summary);

      const body = document.createElement('div');
      body.style.cssText = BODY_STYLE;
      if (summary.id) {
        body.setAttribute('aria-labelledby', summary.id);
      }
      pair.answerNodes.forEach((node) => body.appendChild(node.cloneNode(true)));
      details.appendChild(body);

      details.addEventListener('toggle', function () {
        if (this.open) {
          container.querySelectorAll('.custom-blog-faq-item').forEach((item) => {
            if (item !== this) {
              item.open = false;
            }
          });
        }
        arrow.style.transform = this.open ? 'rotate(180deg)' : '';
      });
      if (details.open) arrow.style.transform = 'rotate(180deg)';

      container.appendChild(details);
    });

    return container;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
